module.exports = __webpack_public_path__ + "img/jr.4abf28f7.png";